// eslint-disable-next-line
import { BasicLayout, RouteView } from '@/layout';
import permission from '@/utils/permission';
import store from '@/store/index';
export const asyncRouterMap = [];

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/',
    name: 'Root',
    component: BasicLayout,
    redirect: store.getters.getConfig.is_header ? '/index' : '/index',
    meta: {
      title: store.getters.getConfig.www_title,
    },
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import('@/views/index.vue'),
        meta: {
          hideMenu: true,
        },
      },
      {
        path: 'admin',
        redirect: '/admin/info',
        component: RouteView,
        meta: {},
        children: [
          {
            path: 'info',
            name: 'AdminInfo',
            component: () => import('@/views/admin/info/info.vue'),
            meta: {
              title: '个人信息',
              hideMenu: false,
            },
          },
          {
            path: 'company',
            name: 'AdminCompany',
            component: () => import('@/views/admin/info/company.vue'),
            meta: {
              title: '我的企业',
              hideMenu: false,
            },
          },
          {
            path: 'p_contract',
            name: 'PContract',
            component: () => import('@/views/admin/p_contract/index.vue'),
            meta: {
              title: '推荐订单',
              hideMenu: false,
            },
          },
          {
            path: 'myteam',
            name: 'MyTeam',
            component: () => import('@/views/admin/team/list.vue'),
            meta: {
              title: '我的团队',
              hideMenu: false,
            },
          },
          {
            path: 'report_linhai',
            name: 'ReportLinhai',
            component: () => import('@/views/admin/report/linhai/list.vue'),
            meta: {
              title: '报表-临海',
              hideMenu: false,
            },
          },
          {
            path: 'report_yuhuan',
            name: 'ReportYuhuan',
            component: () => import('@/views/admin/report/yuhuan/list.vue'),
            meta: {
              title: '报表-玉环',
              hideMenu: false,
            },
          },
          {
            path: 'report_wenling',
            name: 'ReportWenling',
            component: () => import('@/views/admin/report/wenling/list.vue'),
            meta: {
              title: '报表-临海',
              hideMenu: false,
            },
          },

          {
            path: 'contract',
            name: 'AdminContract',
            component: () => import('@/views/admin/contract/index.vue'),
            meta: {
              title: '保函订单',
              hideMenu: false,
            },
          },
          {
            path: 'contract_detail/:id',
            name: 'AdminContractDetail',
            component: () => import('@/views/admin/contract/detail.vue'),
            meta: {
              title: '保函详情',
              hideMenu: false,
            },
          },
          {
            path: 'contract_apply',
            name: 'AdminContractApply',
            component: () => import('@/views/admin/contract/apply.vue'),
            meta: {
              title: '申请保函',
              hideMenu: false,
            },
          },
          {
            path: 'othercontract_apply/:id',
            name: 'AdminContractApply',
            component: () => import('@/views/admin/contract/otherapply.vue'),
            meta: {
              title: '申请其他保函',
              hideMenu: false,
            },
          },
        ],
      },
      {
        path: 'login',
        name: 'WxLogin',
        component: () => import('@/views/login/index.vue'),
        meta: {
          title: '扫码登入',
          hideMenu: true,
        },
      },
      {
        path: 'newss',
        name: 'Newss',
        component: () => import('@/views/news/index.vue'),
        meta: {
          title: '新闻资讯',
          hideMenu: true,
        },
      },
      {
        path: 'news/:id',
        name: 'News',
        component: () => import('@/views/news/detail.vue'),
        meta: {
          title: '新闻资讯',
          hideMenu: true,
        },
      },
      {
        path: 'projects',
        name: 'Project',
        component: () => import('@/views/project/index.vue'),
        meta: {
          title: '工程项目',
          hideMenu: true,
        },
      },
      {
        path: 'contract_check',
        name: 'ContractCheck',
        component: () => import('@/views/contract/check.vue'),
        meta: {
          title: '保函查验',
          hideMenu: true,
        },
      },

      {
        path: 'linhai',
        name: 'Linhai',
        component: RouteView,
        redirect: '/linhai/apply',
        meta: {
          title: '临海公共资源交易中心',
          hideMenu: true,
        },
        children: [
          {
            path: 'apply',
            name: 'LinhaiApply',
            component: () => import('@/views/ggb/linhai/index.vue'),
            meta: {
              title: '保函申请',
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'wenling',
        name: 'Wenling',
        component: RouteView,
        redirect: '/wenling/apply',
        meta: {
          title: '温岭公共资源交易中心',
          hideMenu: true,
        },
        children: [
          {
            path: 'apply',
            name: 'WenlingApply',
            component: () => import('@/views/ggb/wenling/index.vue'),
            meta: {
              title: '保函申请',
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'wenling2',
        name: 'Wenling2',
        component: RouteView,
        redirect: '/wenling2/apply',
        meta: {
          title: '温岭公共资源交易中心(乡镇)',
          hideMenu: true,
        },
        children: [
          {
            path: 'apply',
            name: 'WenlingApply2',
            component: () => import('@/views/ggb/wenling2/index.vue'),
            meta: {
              title: '保函申请',
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'wenlingxz',
        name: 'Wenlingxz',
        component: RouteView,
        redirect: '/wenlingxz/apply',
        meta: {
          title: '温岭公共资源交易中心(乡镇)',
          hideMenu: true,
        },
        children: [
          {
            path: 'apply',
            name: 'WenlingxzApply',
            component: () => import('@/views/ggb/wenlingxz/index.vue'),
            meta: {
              title: '保函申请',
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'taizhou',
        name: 'Taizhou',
        component: RouteView,
        redirect: '/taizhou/apply',
        meta: {
          title: '台州市公共资源交易中心',
          hideMenu: true,
        },
        children: [
          {
            path: 'apply',
            name: 'TaizhouApply',
            component: () => import('@/views/ggb/taizhou/index.vue'),
            meta: {
              title: '保函申请',
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'tzyg',
        name: 'Tzyg',
        component: RouteView,
        redirect: '/tzyg/apply',
        meta: {
          title: '台州市公共资源交易中心',
          hideMenu: true,
        },
        children: [
          {
            path: 'apply',
            name: 'TzygApply',
            component: () => import('@/views/ggb/tzyg/index.vue'),
            meta: {
              title: '保函申请',
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'tiantai',
        name: 'Tiantai',
        component: RouteView,
        redirect: '/tiantai/apply',
        meta: {
          title: '天台市公共资源交易中心',
          hideMenu: true,
        },
        children: [
          {
            path: 'apply',
            name: 'TiantaiApply',
            component: () => import('@/views/ggb/tiantai/index.vue'),
            meta: {
              title: '保函申请',
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'tiantaixs',
        name: 'Tiantaixs',
        component: RouteView,
        redirect: '/tiantaixs/apply',
        meta: {
          title: '天台市小额公共资源交易中心',
          hideMenu: true,
        },
        children: [
          {
            path: 'apply',
            name: 'TiantaixsApply',
            component: () => import('@/views/ggb/tiantaixs/index.vue'),
            meta: {
              title: '保函申请',
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'yuhuan',
        name: 'yuhuan',
        component: RouteView,
        redirect: '/yuhuan/apply',
        meta: {
          title: '玉环公共资源交易中心',
          hideMenu: true,
        },
        children: [
          {
            path: 'apply',
            name: 'YuhuanApply',
            component: () => import('@/views/ggb/yuhuan/index.vue'),
            meta: {
              title: '保函申请',
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'zhejiang',
        name: 'Zhejiang',
        component: RouteView,
        redirect: '/zhejiang/apply',
        meta: {
          title: '浙江省资源交易中心',
          hideMenu: true,
        },
        children: [
          {
            path: 'apply',
            name: 'ZhejiangApply',
            component: () => import('@/views/ggb/zhejiang/index.vue'),
            meta: {
              title: '保函申请',
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'linhaixs',
        name: 'linhaixs',
        component: RouteView,
        redirect: '/linhaixs/apply',
        meta: {
          title: '招天下公共资源交易中心',
          hideMenu: true,
        },
        children: [
          {
            path: 'apply',
            name: 'LinhaixsApply',
            component: () => import('@/views/ggb/linhaixs/index.vue'),
            meta: {
              title: '保函申请',
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: 'liaoning',
        name: 'liaoning',
        component: RouteView,
        redirect: '/liaoning/apply',
        meta: {
          title: '辽宁省公共资源交易中心',
          hideMenu: true,
        },
        children: [
          {
            path: 'apply',
            name: 'LiaoningApply',
            component: () => import('@/views/ggb/liaoning/index.vue'),
            meta: {
              title: '保函申请',
              hideMenu: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404'),
  },
  { path: '*', name: 'other', redirect: '/404', hidden: true },
  {
    path: '/delogin',
    name: 'Delogin',
    component: () => import('@/views/delogin/deindex.vue'),
  },
];

export const useRoleRouter = () => {
  return [
    {
      name: 'MyTeam',
      show: permission(['my_team'], ''),
    },
    {
      name: 'ReportLinhai',
      show: permission(['report', 'linhai'], ''),
    },
  ];
};
